<template>
	<!-- for uploading the products -->
	<div id="page-content" class="admin-sidebar">
		<div class="component-padding">

			<h1>Product Information</h1>
			<p>Fill up all necessary information</p>

			<form id="proposeitem" v-on:submit.prevent="addProduct" method="post" enctype="multipart/form-data">
				<!-- this will hurt a little -->
				<div class="col-md-4">

					<label for="product_name">Product Name</label>
					<input type="text" name="product_name" id="product_name">

					<label for="price">Price (Php)</label>
					<input type="text" name="price" id="price">

					<label for="stock">No. of Available Stock</label>
					<input type="text" name="stock" id="stock">

				</div>

				<div class="col-md-4">
					
					<label for="color">Color</label>
					<input type="text" name="color" id="color">

					<label for="category">Category</label>
					<select name="category" id="category">
						<option value="" selected>select category</option>
						<option value="light">light</option>
						<option value="dark">dark</option>
					</select>

					<label for="led">Led Capable</label>
					<select name="led" id="led">
						<option value="YES" selected>Yes</option>
						<option value="NO">No</option>
					</select>

				</div>

				<div class="col-md-4">
					<label for="material">Material</label>
					<select name="material" id="material">
						<option value="" selected>Select Material</option>
						<option value="wood">wood</option>
						<option value="glass">glass</option>
						<option value="concrete">concrete</option>
					</select>

					<label for="image">Product Image</label>
					<input type="file" name="image" id="image" style="border">
				</div>

				<input type="hidden" id="token" name="token" :value="token" />

				<div style="clear: both;"></div>
				<div class="pull-right" style="padding: 0px 15px; margin-top: 40px;">
					<button class="button-type-e" type="submit">Upload Product</button>
				</div>
			</form>
		</div>
	</div>
</template>

<script>
	export default{
		data(){
			return{
				token: ''
			}
		},
		methods: {
			addProduct: function(event){
				var self = this;
				var product_name = $(event.target).find('#product_name').val();
				var price = $(event.target).find('#price').val();
				var category = $(event.target).find('#category').val();
				var material = $(event.target).find('#material').val();
				var stock = $(event.target).find('#stock').val();
				var color = $(event.target).find('#color').val();
				var led = $(event.target).find('#led').val();
				var image = $(event.target).find('#image')[0].files[0];
				//this is the token
				var token = $(event.target).find('#token').val();
				//var product_image = $(event.target).find('input[name="product_image"]')[0].files[0];

				var formData = new FormData()

				formData.append('product_name', product_name);
				formData.append('price', price);
				formData.append('category', category);
				formData.append('material', material);
				formData.append('stock', stock);
				formData.append('color', color);
				formData.append('led', led);
				formData.append('image', image);
				//this is the token
				formData.append('token', token);
				//formData.append('product_image', product_image);
				

				
				$.ajax({
					url: 'static/php/adminupload.php',
					type: 'POST',
					data: formData,
					cache: false,
					contentType: false,
					processData: false,
					success: function(data){
						console.log(data);
						alert(data);
					}
				});
				
			}
		},
		created(){
			var self = this;
			$.ajax({
				url: 'static/php/gettoken.php',
				success: function(data){
					if(typeof data === "string"){
						self.token = data;
					}
				}
			});
		},
		mounted(){
			relativeTo('nav', this.$el);
		}
	}
</script>


// WEBPACK FOOTER //
// AdminProducts.vue?fa5004e4